import { useScanExport, dismissUnseen } from '../scanExportStore';
import { useExportRun, isExportTabOpen, dismissExportUnseen } from '../exportRunStore';

// The session-level runs (Scan export, Export run) as one thing for the bars that show them from any tab:
//   running  → { label, sub, done, total } | null     (two at once: the first one's bar, the second named in `sub`)
//   finished → { text, dismiss } | null                (ended while the user was elsewhere)
// The Export run is left out while the Export tab itself is open: its own bar shows it.
export default function useBackgroundRuns() {
  const scan = useScanExport();
  const exp = useExportRun();
  const exportHere = isExportTabOpen();
  const runs = [];
  if (scan.running) runs.push({ label: scan.total ? `Scan export · ${scan.done} / ${scan.total}` : 'Scan export', sub: scan.msg, done: scan.done, total: scan.total });
  if (exp.running && !exportHere) runs.push({ label: `Export · ${exp.done} / ${exp.total}`, sub: exp.current, done: exp.done, total: exp.total });
  const running = runs.length ? Object.assign({}, runs[0], runs[1] ? { sub: [runs[0].sub, runs[1].label].filter(Boolean).join(' · ') } : {}) : null;
  let finished = null;
  if (!running) {
    if (scan.unseen) finished = { text: `Scan export finished · ${scan.msg}`, dismiss: dismissUnseen };
    else if (exp.unseen && !exportHere) finished = { text: `Export finished · ${exp.summary}`, dismiss: dismissExportUnseen };
  }
  return { running, finished };
}
